/**
 * Sumy Neighborhood Map entry module.
 *
 * Loads Google Maps from the browser, then initializes the map after DOM ready.
 */

import { loadGoogleMaps } from './load-maps.js';
import { initMap } from './init-map.js';
import {
	bindViewButtons,
	bindMapControls,
	bindInfoWindowNavigation,
} from './controls.js';

console.log( 'Faceted Map plugin loaded.' );

/**
 * Bootstraps UI bindings, Maps API load, and map init.
 *
 * @return {Promise<void>}
 */
async function bootstrap() {
	bindViewButtons();
	bindMapControls();
	bindInfoWindowNavigation();

	const apiKey = window.sumy_map?.google_api_key;
	await loadGoogleMaps( apiKey );
	await initMap();
}

document.addEventListener( 'DOMContentLoaded', () => {
	bootstrap().catch( ( error ) => {
		console.error( 'Sumy Neighborhood Map failed to start:', error );
	} );
} );
